import { useRouter } from "next/router";
import Head from "next/head";
import Footer from "../components/Footer";
import CTA from "../components/landingpage/CTA";
import Script from "next/script";
import Image from "next/image";
import Share from "../components/landingpage/Share";
import Link from "next/link";
import Navbar from "../components/Navbar";
import { useContext, useEffect, useState } from "react";

import { FirebaseContext } from "../contexts/FirebaseContext";
import { saveLaunchEmail } from "../firebase/firebaseLaunch";
import { addLaunchEmail } from "../firebase/whitelist";

const Launch = () => {
  const router = useRouter();

  const { auth } = useContext(FirebaseContext);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [launchEmail, setLaunchEmail] = useState("");

  const emailSubmitClick = async (e) => {
    e.preventDefault();
    await addLaunchEmail(launchEmail);
    await router.push({
      pathname: "/launch-thankyou",
      query: {
        email: launchEmail,
      },
    });
  };

  return (
    <>
      <Navbar />
      <Head>
        <title>ocena | 오세나 론칭</title>
        <link rel="icon" href="/assets/favicon.ico" />
      </Head>
      <Script
        id="prefinery-script"
        src="https://widget.prefinery.com/widget/v2/qtvascno.js"
        defer
      ></Script>

      {/* max-w-[83rem] */}
      <div className=" h-full w-full scroll-smooth bg-white font-kr text-zinc-700 selection:bg-zinc-700 selection:text-zinc-100 ">
        <div className="relative bg-cust_blue">
          <img
            src="/assets/icon-stamp.png"
            alt="stamp icon"
            className="absolute right-0 top-5 w-1/2 max-w-[16rem] md:w-1/3 lg:top-10 lg:right-12 lg:w-64 xl:right-24 xl:w-80"
          ></img>
          <img
            src="/assets/icon-heart.png"
            alt="heart icon"
            className="absolute left-10 bottom-0 w-52 md:bottom-10 lg:bottom-20 lg:left-16 xl:left-24 xl:bottom-40   "
          ></img>
          <div className="bg-[url('/assets/noise.png')] bg-repeat	backdrop-brightness-95">
            <div className="mx-auto max-w-[83rem] items-center justify-center 	px-4 pt-40 pb-28 md:px-8 lg:flex  lg:space-x-20 lg:pb-40 lg:pt-48">
              <div className="flex w-full flex-col items-center justify-center">
                <h1 className="whitespace-nowrap text-center text-5xl font-bold leading-snug text-white lg:text-6xl xl:leading-normal ">
                  {/* <span className="underline decoration-primary/60 decoration-8 underline-offset-0 xl:decoration-[10px]">
                    견적에서 매출까지
                  </span> */}
                  프로덕트 출시 <br className="md:hidden" />
                  사전신청
                </h1>
                <p className="mt-6 w-full max-w-lg whitespace-normal text-center text-white lg:text-lg">
                  단 한 번의 거래 정보 입력으로 견적서, 세금계산서, 거래명세서,{" "}
                  <br className="hidden md:block" />
                  정산관리 등 번거로운 영업지원 업무를 한 번에 처리하세요.
                </p>

                <form
                  className="flex w-full flex-col"
                  onSubmit={(e) => {
                    emailSubmitClick(e);
                  }}
                >
                  <div className="mt-10 flex flex-col items-center justify-center space-y-6 space-x-3 md:flex-row md:space-y-0">
                    <div className="flex w-full flex-col items-center px-4 md:w-auto md:px-0 ">
                      <input
                        required
                        id="user-email"
                        type="email"
                        placeholder="tom@example.com"
                        className="h-[4.5rem] w-full max-w-[25rem] rounded-full border-4 border-white px-7 font-medium text-cust_blue transition-all focus:border-4 focus:border-red-400 focus:outline-none md:w-[20rem] md:max-w-none "
                        onChange={(e) => {
                          setLaunchEmail(e.target.value);
                        }}
                      ></input>
                    </div>
                    <div className="relative ">
                      <div className="absolute inset-0 z-0 flex h-[4.5rem] w-[10rem] items-center justify-center rounded-full border-[3px] border-zinc-600 bg-zinc-600 "></div>
                      <input
                        value="사전신청하기"
                        type="submit"
                        className="z-100 flex h-[4.5rem] w-[10rem] items-center justify-center rounded-full border-[3px] border-white bg-[#FF3B30] text-lg font-bold text-white transition-all duration-150 ease-in-out will-change-transform hover:translate-y-[-4px] hover:translate-x-[-2px] hover:cursor-pointer focus:translate-y-[-1px] focus:translate-x-[-1px] focus:bg-zinc-300 active:duration-100 "
                      ></input>
                    </div>
                  </div>
                  <div className=" mt-4 flex items-center justify-center ">
                    <input
                      id="link-checkbox"
                      type="checkbox"
                      value=""
                      required
                      className="h-4 w-4 rounded-xl hover:cursor-pointer"
                    ></input>
                    <label className="ml-2 text-sm font-medium text-zinc-300  ">
                      만 14세 이상임을 확인하고, &nbsp;
                      <Link href="/terms" className="hover:underline">
                        개인정보 수집 및 이용
                      </Link>
                      에 동의합니다.
                    </label>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="z-100 absolute bottom-0 h-3 w-full rotate-180">
            <div className="h-full w-full bg-[url('/assets/segment.png')] bg-contain bg-repeat-x"></div>
          </div>
        </div>

        {/* 로고 배너 */}

        <div className="relative mx-auto w-full max-w-7xl bg-white px-4 py-8 md:px-6">
          <div className="inline-flex w-full flex-nowrap overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-200px),transparent_100%)]">
            <ul className="flex animate-infinite-scroll items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-h-10 [&_img]:max-w-[10rem]">
              {/* {LOGOS.map((logo, index) => (
                <li className="" key={index}>
                  {logo}
                </li>
              ))} */}
              <li>
                <img
                  src="/assets/customer_logos/AK.png"
                  alt="AK"
                  className=" "
                />
              </li>

              <li>
                <img
                  src="/assets/customer_logos/stepping.png"
                  alt="stepping"
                  className=""
                />
              </li>

              <li>
                <img
                  src="/assets/customer_logos/indigo.png"
                  alt="indigo"
                  className=" pt-1"
                />
              </li>

              <li>
                <img
                  src="/assets/customer_logos/fleetune.png"
                  alt="fleetune"
                  className="w-[9rem] "
                />
              </li>

              <li>
                <img
                  src="/assets/customer_logos/jober.png"
                  alt="jober"
                  className="pt-1 "
                />
              </li>

              <li>
                <img
                  src="/assets/customer_logos/meissa.png"
                  alt="meissa"
                  className="h-9 "
                />
              </li>

              <li>
                <img
                  src="/assets/customer_logos/daytrip.png"
                  alt="daytrip"
                  className="h-9 pt-1"
                />
              </li>

              <li>
                <img
                  src="/assets/customer_logos/relate.png"
                  alt="relate"
                  className="h-7 "
                />
              </li>

              <li>
                <img
                  src="/assets/customer_logos/safetics.png"
                  alt="safetics"
                  className="h-7 "
                />
              </li>

              <li>
                <img
                  src="/assets/customer_logos/searchfi.png"
                  alt="searchfi"
                  className=" "
                />
              </li>

              <li>
                <img
                  src="/assets/customer_logos/2080.png"
                  alt="2080"
                  className=" "
                />
              </li>
            </ul>
            <ul
              className="flex animate-infinite-scroll items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-h-10 [&_img]:max-w-[10rem]"
              aria-hidden="true"
            >
              {/* {LOGOS.map((logo, index) => (
                <li className="" key={index}>
                  {logo}
                </li>
              ))} */}
              <li>
                <img
                  src="/assets/customer_logos/AK.png"
                  alt="AK"
                  className=" "
                />
              </li>

              <li>
                <img
                  src="/assets/customer_logos/stepping.png"
                  alt="stepping"
                  className=""
                />
              </li>

              <li>
                <img
                  src="/assets/customer_logos/indigo.png"
                  alt="indigo"
                  className=" pt-1"
                />
              </li>

              <li>
                <img
                  src="/assets/customer_logos/fleetune.png"
                  alt="fleetune"
                  className="w-[9rem] "
                />
              </li>

              <li>
                <img
                  src="/assets/customer_logos/jober.png"
                  alt="jober"
                  className="pt-1 "
                />
              </li>

              <li>
                <img
                  src="/assets/customer_logos/meissa.png"
                  alt="meissa"
                  className="h-9 "
                />
              </li>

              <li>
                <img
                  src="/assets/customer_logos/daytrip.png"
                  alt="daytrip"
                  className="h-9 pt-1"
                />
              </li>

              <li>
                <img
                  src="/assets/customer_logos/relate.png"
                  alt="relate"
                  className="h-7 "
                />
              </li>

              <li>
                <img
                  src="/assets/customer_logos/safetics.png"
                  alt="safetics"
                  className="h-7 "
                />
              </li>

              <li>
                <img
                  src="/assets/customer_logos/searchfi.png"
                  alt="searchfi"
                  className=" "
                />
              </li>

              <li>
                <img
                  src="/assets/customer_logos/2080.png"
                  alt="2080"
                  className=" "
                />
              </li>
            </ul>
          </div>
        </div>

        <div className="absolute z-10 h-3 w-full">
          <div className="h-full w-full bg-[url('/assets/segment.png')] bg-contain bg-repeat-x"></div>
        </div>

        {/* <div className="mt-32 w-full flex-col">
            <h2 className="text-center text-2xl font-bold lg:text-4xl">
              <span className="underline decoration-primary/60 decoration-8 underline-offset-0">
                세일스보드
              </span>
            </h2>
            <p className="mt-4 text-center text-sm lg:text-base">
              한 개의 세일스보드 안에서 견적에서 매출까지의 과정을 관리하세요.{" "}
            </p>
            <img
              src="/assets/sales-process.png"
              alt="오세나 세일스보드 적용 영업 프로세스"
              className="mt-6"
            ></img>
          </div> */}

        <div className=" bg-cust_yellow px-4 pt-20 pb-20 text-cust_blue md:px-8">
          <div className="mx-auto  flex flex-col items-center">
            <h2 className="whitespace-normal text-center text-3xl font-bold leading-normal md:whitespace-nowrap md:text-4xl  ">
              번거로운 영업지원 <br className="md:hidden" /> 업무가 간단해집니다
            </h2>
          </div>
          <div className="mx-auto mt-14 flex w-full max-w-[65rem] flex-col justify-center space-y-14 md:flex-row md:space-y-0">
            <div className=" w-full justify-between lg:flex lg:space-x-32">
              <div className="flex w-full flex-col items-center justify-center ">
                <img
                  src="/assets/icon-quote.png"
                  alt="오세나 세일스보드 적용 영업 프로세스"
                  className="mt-6 w-40"
                ></img>
                <h3 className=" mt-8 whitespace-nowrap text-xl font-bold leading-snug lg:text-2xl">
                  01 견적서
                </h3>
                <div className=" mt-6 whitespace-nowrap text-center text-lg font-normal leading-snug text-zinc-500 ">
                  쉽고 빠르게 <br /> 견적서를 만드세요
                </div>
              </div>
            </div>

            <div className=" w-full justify-between lg:flex lg:space-x-32">
              <div className="flex w-full flex-col items-center justify-center ">
                <img
                  src="/assets/icon-billing.png"
                  alt="오세나 세일스보드 적용 영업 프로세스"
                  className="mt-6 w-40"
                ></img>
                <h3 className=" mt-8 whitespace-nowrap text-xl font-bold leading-snug lg:text-2xl">
                  02 정산 관리
                </h3>
                <div className=" mt-6 whitespace-nowrap text-center text-lg font-normal leading-snug text-zinc-500">
                  복잡한 거래 조건에 대한 <br /> 정산 관리를 쉽게 처리하세요
                </div>
              </div>
            </div>

            <div className=" w-full justify-between lg:flex lg:space-x-32">
              <div className="flex w-full flex-col items-center justify-center ">
                <img
                  src="/assets/icon-tax.png"
                  alt="오세나 세일스보드 적용 영업 프로세스"
                  className="mt-6 w-40"
                ></img>
                <h3 className=" mt-8 whitespace-nowrap text-xl font-bold leading-snug lg:text-2xl">
                  03 세금계산서
                </h3>
                <div className=" mt-6 whitespace-nowrap text-center text-lg font-normal leading-snug text-zinc-500">
                  클릭 한번으로 <br /> 세금계산서를 발행하세요
                </div>
              </div>
            </div>
          </div>
          <div className="mt-20 flex w-full justify-center">
            <div className="relative ">
              <div className="absolute inset-0 z-0 flex h-[4.5rem] w-[12.5rem] items-center justify-center rounded-full border-[3px] border-zinc-400 bg-zinc-400 "></div>
              <button
                onClick={(e) => {
                  router.push("/");
                }}
              >
                <div className="z-100 flex h-[4.5rem] w-[12.5rem] translate-y-[-4px] translate-x-[-2px] items-center justify-center rounded-full border-[3px] border-zinc-500 bg-white text-lg font-bold text-cust_blue transition-all duration-150 ease-in-out will-change-transform hover:translate-y-0 hover:translate-x-0 hover:bg-white focus:translate-y-[-1px] focus:translate-x-[-1px] focus:bg-zinc-300 active:duration-100 ">
                  더 알아보기 &nbsp; →
                </div>
              </button>
            </div>
          </div>
        </div>

        {/* End of section */}
      </div>

      <Footer />
    </>
  );
};

export default Launch;
